const sleep = (time) => new Promise((acc) => setTimeout(acc, time));

export default sleep;
